module.exports = __webpack_public_path__ + "img/hand.4bb74b55.jpg";